<template>
    <!-- Header -->
    <div class="nav-wrapper">
      <nav class="navbar navbar-default">
        <div class="container navbar-container">
          <div class="navbar-header">
            <a href="https://www.megaphone.org.uk/"><img class="logo" src="../assets/img/logo.png" alt="" /></a>
          </div>
        </div>
      </nav>
    </div>
</template>

<script>
export default {
  name: 'Header',
  props: {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.nav-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  box-shadow: 0 5px 10px rgba(70,70,70,0.1);
}
.navbar {
  height: 100px;
  padding: 0;
  background: #fff;
  .navbar-header {
    @media only screen and (max-width: 768px) {
      text-align: center;
      width: 100%;
    }
  }
  .container-fluid {
    padding: 0;
  }
  .logo {
    height: 90px;
    width: auto;
  }
}
</style>